export const requestAlertsQuery = () => `
  query RequestAlerts ($fromDate: DateTime, $toDate: DateTime) {
    alerts (
      fromDate: $fromDate
      toDate: $toDate
    ) {
      show
      valid
      id
      description
      description_long
      ad_id
      ad_alert_id
      ad_created_timestamp
      ref_date
      ref_timestamp
      ad_description
      symbol
      order_id
      trade_id
      private_order_id
      private_trade_id
      private_trade_report_id
      private_client_id
      order_value
      outside_spread
      ad_username
      ad_groupid
      pricechange
      trader_id
      generated_limit
      currency
      volume
      trade_class
      order_age {
        years
        months
        days
        hours
        minutes
        seconds
        milliseconds
      }
      daydiff
      newstitle
      newstimestamp
      timediff {
        years
        months
        days
        hours
        minutes
        seconds
        milliseconds
      }
      security_type
      ap_id
      ap_alert_id
      ap_description
      ap_description_long
      ac_alert_id
      param_id
      ac_groupid
      ac_username
      value
      ac_created_timestamp
      config_id
      adu_alert_data_id
      adu_groupid
      adu_username
      alert_comment
      comment_timestamp
      status,
      review_id
    }
  }
`;

export const requestAlertsConfigQuery = () => `
  {
    alertConfigs {
      id
      description
      description_long
      private
      shares
      bonds
      currency
      alertConfigParameters {
        id
        alert_id
        description
        description_long
        default_value
        default_value_text
        alertConfigParameterHistory {
          config_id
          alert_id
          value
          value_text
          username
          param_id
          created_timestamp
          groupid
        }
      }
    }
  }
`;

export const modifyAlertConfigsQuery = () => `
  mutation AddAlertConfigParamter ($changeInputs: [AlertConfigParameterChange!]!) {
    addAlertConfigParameter (
      alertConfigParameterInputs: $changeInputs
    ) {
      id
      description
      description_long
      private
      shares
      bonds
      currency
      alertConfigParameters {
        id
        alert_id
        description
        description_long
        default_value
        default_value_text
        alertConfigParameterHistory {
          config_id
          alert_id
          value
          value_text
          username
          param_id
          created_timestamp
          groupid
        }
      }
    }
  }
`;

export const requestAlertReviewHistoryQuery = () => `
  query GetAlertReviewHistory ($alertDataId: Float!) {
    alertReviewHistory (
      alertDataId: $alertDataId
    ) {
      alert_data_id,
      username,
      comment_timestamp,
      alert_comment,
      status,
      groupid,
      review_id,
      attachments {
        alert_review_id
        s3_key
        filename
        content_type
        file_size_bytes
        uploaded_timestamp
        url
      }
    }
  }
`;

export const addAlertReviewHistoryEntryQuery = () => `
  mutation AddReviewHistoryEntry ($alertReviewInput: AlertReviewInput!) {
    addReviewHistory(
      alertReviewInput: $alertReviewInput
    ) {
      alert_data_id,
      comment_timestamp,
      alert_comment,
      status,
      username,
      groupid
      review_id
    }
  }
`;

export const loginQuery = () => `
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
    }
  }
`;

export const logoutQuery = () => `
  mutation Logout {
    logout {
      success
    }
  }
`;


export const requestPrivateUserInfoQuery = () => `
  query privateUserInfo {
    privateUserInfo {
      organization
      userName
    }
  }
`;

export const uploadFileMutation = () => `
  mutation addAlertReviewAttachment($file: Upload!, $reviewId: Float!, $groupId: String!) {
    addAlertReviewAttachment(file: $file, review_id: $reviewId, groupId: $groupId) {
      id
      alert_review_id
      s3_key
      filename
      content_type
      file_size_bytes
      uploaded_timestamp
    }
  }
`;
